import { render, staticRenderFns } from "./DaturaView.vue?vue&type=template&id=6c75be4e&scoped=true&"
import script from "./DaturaView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DaturaView.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c75be4e",
  null
  
)

export default component.exports